export default function hydrateRecentlySearchedWithListingsActionCreator(recentSearchDuck, personalization) {
  return _ref => {
    let {
      carouselCount = 1
    } = _ref;
    return async (dispatch, getState) => {
      try {
        const results = [];
        const searches = recentSearchDuck.selectors.getRecentSearches(getState());
        let index = 0;
        while (results.length < carouselCount && index < searches.length) {
          const search = searches[index];
          const {
            query
          } = search;
          // The iterations of a loop are not actually independent of each-other
          // eslint-disable-next-line no-await-in-loop
          const searchListings = await personalization.getRecentlySearchedInventory({
            ...query,
            myatcLastExecution: query.lastExec,
            numRecords: 12
          });
          if (searchListings && searchListings.listings) {
            const recentSearchInventory = {
              ...search,
              ...searchListings
            };
            results.push(recentSearchInventory);
          }
          index += 1;
        }
        dispatch(recentSearchDuck.creators.setRecentSearchesInventory(results));
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    };
  };
}